import ReportHeaderBarItems from 'app/common/templates-next/report-template/report-header-bar-items'
import { ReportType } from 'app/dataTypes/reports'

import { History } from 'app/components/common/reports/v3/history'
import { ReportFile } from 'app/components/common/reports/ReportFile/report-file'
import { ReportFileFormat } from 'app/common/types/reports/generateFile'

const filenameBase = ReportType.OrdersByClasses.replace(/-/g, '_')

type Props = {
  reportID: string | null
  reportReady: boolean
}

export const HeaderBar = ({ reportID, reportReady }: Props) => {
  return (
    <ReportHeaderBarItems>
      {reportID && reportReady &&
        <ReportFile
          reportID={reportID}
          filenameBase={filenameBase}
          format={ReportFileFormat.DOCX}
        />}

      <History reportType={ReportType.SubsidiesAct} filenameBase={filenameBase} />
    </ReportHeaderBarItems>
  )
}
